module.exports = __webpack_public_path__ + "static/media/MUST.ef52d1c3.png";